import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { FieldWrapper, FileInput } from '@/components/Form'

import {
  Button,
  Flex,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { selectAddCustomerModal, useAddCustomerModalManagement } from '@/stores/offers/addCustomerModalSlice'

// Logic

const AddCustomerModal = () => {
  const { isOpened, title, customerName, BRNo, submit, close } = useAddCustomerModalManagement()

  const methods = useForm()

  useEffect(() => {
    methods.setValue('customerName', customerName ?? '')
    methods.setValue('BRNo', BRNo ?? '')
  }, [customerName, BRNo, methods])

  const closeModal = () => {
    close()
    methods.reset({
      customerName: '',
      BRNo: '',
    })
  }

  const onSubmit = ({ customerName, damexEFile, BRNo }) => {
    if (!customerName) {
      toast.error('Missing Customer Name')
      return
    }

    submit({
      customerName,
      BRNo,
    })
    closeModal()
  }

  return (
    <Modal isOpen={isOpened} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW="30%">
        <FormProvider {...methods}>
          <form>
            <ModalHeader>{title}</ModalHeader>

            <ModalCloseButton />
            <ModalBody>
              <Flex gap={3} direction={'column'}>
                <FieldWrapper isRequired={true} tooltip={'Customer Name'} label={'Customer Name'}>
                  <Input name="customerName" label="Customer Name" {...methods.register('customerName')} />
                </FieldWrapper>

                <FieldWrapper isRequired={false} tooltip={'BR No.'} label={'BR No.'}>
                  <Input name="BRNo" label="BR No." {...methods.register('BRNo')} />
                </FieldWrapper>
              </Flex>
            </ModalBody>

            <ModalFooter>
              <HStack>
                <Button colorScheme="green" onClick={methods.handleSubmit(onSubmit)}>
                  Confirm
                </Button>

                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default AddCustomerModal
